export interface DeleteWorkSpaceRequest {
    workspaceId: number
}

export const DeleteWorkSpaceRequestInit: DeleteWorkSpaceRequest = {
    workspaceId: 0,
}